exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._1J5IR4X7KuJxq06-aq_5c2{display:table;table-layout:fixed;width:100%;height:100%}._2D1fuegOiXxswYHGNZ91W,._2fs9E5S6prHnf0Uu_eqY5y{display:table-cell;height:100%;width:100%}._2D1fuegOiXxswYHGNZ91W{vertical-align:middle}._2fs9E5S6prHnf0Uu_eqY5y{vertical-align:bottom}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/atoms/Valign/style.css"],"names":[],"mappings":"AAAA,yBACC,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,WAAa,CACb,AACD,iDAEC,mBAAoB,AACpB,YAAa,AACb,UAAY,CACZ,AACD,wBAAgB,qBAAuB,CAAE,AACzC,yBAAgB,qBAAuB,CAAE","file":"style.css","sourcesContent":[".valign{\n\tdisplay: table;\n\ttable-layout: fixed;\n\twidth: 100%;\n\theight: 100%;\n}\n.valignMiddle,\n.valignBottom{\n\tdisplay: table-cell;\n\theight: 100%;\n\twidth: 100%;\n}\n.valignMiddle { vertical-align: middle; }\n.valignBottom { vertical-align: bottom; }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"valign": "_1J5IR4X7KuJxq06-aq_5c2",
	"valignMiddle": "_2D1fuegOiXxswYHGNZ91W",
	"valignBottom": "_2fs9E5S6prHnf0Uu_eqY5y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/atoms/Valign/style.css
// module id = 797
// module chunks = 0 1 2 3 13 16